import { render, staticRenderFns } from "./AddFaq.vue?vue&type=template&id=934fa16a&scoped=true&"
import script from "./AddFaq.vue?vue&type=script&lang=js&"
export * from "./AddFaq.vue?vue&type=script&lang=js&"
import style0 from "./AddFaq.vue?vue&type=style&index=0&id=934fa16a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "934fa16a",
  null
  
)

export default component.exports